import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {UntypedFormGroup} from '@angular/forms';
import {ExpertiseAreaRestService} from '../../services/expertise-area/expertise-area-rest.service';
import {ExpertiseAreaGetResponse} from '../../types/person/expertise-area-get-response';
import {SystemType} from '../../types/common/system-type';

@Component({
  selector: 'wsd-select-expertise-areas',
  templateUrl: './select-expertise-areas.component.html',
  styleUrls: ['./select-expertise-areas.component.css']
})
export class SelectExpertiseAreasComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_EXPERTISE_AREA.LABEL';

  @Input()
  controlName: string = 'expertiseAreas';

  @Input()
  showLabel: boolean = true;

  @Output()
  private onChange = new EventEmitter<void>();

  expertiseItems: SelectItem[] = [];

  constructor(private expertiseAreaService: ExpertiseAreaRestService) { }

  ngOnInit() {
    this.loadRoles();
  }

  private loadRoles() {
    this.expertiseAreaService.getExpertiseAreas(250, 0, '').subscribe(
      (areas: ExpertiseAreaGetResponse) => {
        this.expertiseItems = areas.content.map(area => {
          // TODO: nastavujeme typ pretoze chodi z BE. Treba odstranit!
          area.type = SystemType.DIRECTORY;
          return {
            label: area.name,
            value: area
          };
        });
      }
    );
  }

  change(event) {
    this.onChange.emit();
  }

}
